import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';
export interface CatpProtectionStoreState {
  activityOperations: any[];
}
export default {
  actions: {
    catpProtectionRedirect(context: ActionContext<CatpProtectionStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'catp/protectionredirect';
      return ApiServiceWrapper.post(endpoint, payload);
    },
  },
  namespaced: true,
} as Module<CatpProtectionStoreState, RootStoreState>;
